import { useEffect } from 'react'
import { useSafeState } from 'ahooks'

const g = {
  socket: {}
}
export default g

export const useWS = ({ channel, onSubscribe, onUnsubscribe }) => {
  const [dataSource, setDataSource] = useSafeState({})

  useEffect(() => {
    if (channel) {
      g.socket.subscribe({
        channel,
        onMessage: ({ content }) => {
          onSubscribe?.()
          const data = JSON.parse(content)
          setDataSource(data)
        }
      })
    }
    return () => {
      if (!channel) return
      g.socket.unsubscribe({
        channel
      })
      onUnsubscribe?.()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, setDataSource])

  return { latestMessage: dataSource }
}
